<template>
  <div class="incenters">
    <!-- style="border: 1px solid red;" -->
    <div style="">
      <Commonbtn v-if="qx.add" backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')" title="新增" fontSize="14px" @btnclick="adduser">
      </Commonbtn>
      <Commonbtn v-if="qx.update" :useAutoOptional="false" backgroundColor="#FFF" :src="require('@/assets/icon/icon-update.png')" title="修改" fontSize="14px" @btnclick="updateclick">
      </Commonbtn>
      <Commonbtn v-if="qx.del" backgroundColor="#FFF" :src="require('@/assets/icon/icon-del.png')" title="删除" fontSize="14px" @btnclick="del">
      </Commonbtn>
      <Commonbtn v-if="qx.enabled" backgroundColor="#FFF" :src="require('@/assets/icon/qy.png')" title="启用" fontSize="14px" @btnclick="qy">
      </Commonbtn>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth">
      <Commontable @onRowClick="onRowClick" colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
      </Commontable>
      <div class="pagination">
        <!-- <Pagination></Pagination> -->
      </div>
    </div>
    <DialogFrom width="670px" title="新增部门" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
      <div class="from">
        <template v-for="(item , index) of fromdataadd">
          <Commondropdownlist :key="index" ref="deptadd" :options="item.options" :min="item.min" :max="item.max" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
    <DialogFrom width="670px" title="修改用户" :dialogVisible="dialogVisiblesedit" @cancel="canceledit" @dialogOK="dialogOKedit">
      <div class="from">
        <template v-for="(item , index) of fromdataedit">
          <Commondropdownlist :key="index" ref="deptupdate" :options="item.options" :inputdata="item.inputdata" @handleChange="handleChange" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该用户吗？</span>
    </Dialog>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleqy" @cancel="cancelqy" @dialogOK="dialogOKqy" :src="require('@/assets/icon/icon-errors.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要启用该用户吗？</span>
    </Dialog>
  </div>
</template>
<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import Commontable from '../../../components/common-table.vue'
import Commonbtn from '../../../components/common-btn.vue'
import Pagination from '../../../components/pagination.vue'
import DialogFrom from '../../../components/dialog-from.vue'
import Dialog from '../../../components/dialog.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import { OrganizationInfo, OrganizationAdd, OrganizationEdit, OrganizationDelete, OrganizationSetEnable } from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    DialogFrom,
    Commondropdownlist,
    Dialog
  },
  props: {
    tableData: {
      type: Array,
      default: Array
    }
  },
  data: function () {
    return {
      dialogVisibles: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      dialogVisibleqy: false,
      username: '',
      name: '',
      ptype: '',
      type: '',
      zname: '',
      parentId: '',
      cCompanyID: '',
      rowboo: false,
      fromdataadd: [],
      fromdataedit: [],
      resdetailsList: {},
      qus: [],
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false
      },
      headerData: [{
        prop: 'id',
        label: '序号',
        columnwidth: 50
      },
      {
        prop: 'CCompanyID',
        label: '组织代码',
        columnwidth: 180
      },
      {
        prop: 'Name',
        label: '组织名称',
        columnwidth: 180
      },
      {
        prop: 'ParentId',
        label: '上级组织',
        columnwidth: 120
      },
      {
        prop: 'Sortnum',
        label: '排序编号',
        columnwidth: 120
      },
      {
        prop: 'Remark',
        label: '备注',
        columnwidth: 180
      },
      {
        prop: 'Addition1',
        label: '电话',
        columnwidth: 150
      },
      {
        prop: 'Addition2',
        label: '邮箱',
        columnwidth: 180
      },
      {
        prop: 'Disabled',
        label: '是否启用',
        columnwidth: 200
      },
      ],
    }
  },
  created() {
  },
  mounted() {
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
    this.QX()
  },
  methods: {
    QX() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
      data.Menus.map((item,index)=>{
        if(item.NodeID == 1){
            item.Nodes.map((items,indexs)=>{
              if(items.NodeID == 8){
                   this.qus = items.Nodes
              }
            })
        }
      })
      this.qus.map((item, index) => {
        if (item.NodeName == 'add') {
          this.qx.add = true
        } else if (item.NodeName == 'edit') {
          this.qx.update = true
        } else if (item.NodeName == 'delete') {
          this.qx.del = true
        } else if (item.NodeName == 'stopif') {
          this.qx.del = true
        } else if (item.NodeName == 'assignment') {
          this.qx.assignment = true
        }
      })
    },
    // 新增部门列表
    async organizationAdd(datalist) {
      let addcode = await OrganizationAdd({
        // accSuite:  datalist[0].inputdata[datalist[0].inputdata.length-1],
        // disabled: datalist[1].inputdata,
        // type: datalist[1].inputdata,
        // vouchCodePrefix: datalist[1].inputdata
        cCompanyID: datalist[1].modelvalue,
        addition1: datalist[4].modelvalue,
        addition2: datalist[5].modelvalue,
        name: datalist[2].modelvalue,
        parentId: datalist[0].modelvalue[datalist[0].modelvalue.length - 1],
        remark: datalist[6].modelvalue,
        sortnum: datalist[3].modelvalue,
      })
      if (addcode.code == 0) {
        this.$message({
          type: 'success',
          message: '新增成功'
        });
        this.rowboo = false
        this.$parent.organizationList()

      } else {
        this.$message({
          type: 'error',
          message: addcode.message
        });

      }
      this.$refs.deptadd.map((item, index) => {
        item.modelvalue = ''
      })
      //console.log("addcode", addcode)
    },
    // 修改部门列表
    async organizationEdit(datalist) {
      let addcode = await OrganizationEdit({
        // accSuite:  datalist[0].inputdata[datalist[0].inputdata.length-1],
        // disabled: datalist[1].inputdata,
        // type: datalist[1].inputdata,
        // vouchCodePrefix: datalist[1].inputdata
        cCompanyID: datalist[1].modelvalue,
        addition1: datalist[4].modelvalue,
        addition2: datalist[5].modelvalue,
        name: datalist[2].modelvalue,
        parentId: datalist[0].modelvalue,
        remark: datalist[6].modelvalue,
        sortnum: datalist[3].modelvalue,
      })
      if (addcode.code == 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        });
        this.dialogVisiblesedit = false
        this.rowboo = false
        this.$parent.organizationList()
      } else {
        this.$message({
          type: 'error',
          message: addcode.message
        });
        this.dialogVisiblesedit = false
      }
      this.$refs.deptupdate.map((item, index) => {
        item.modelvalue = ''
      })
      //console.log("addcode", addcode)
    },
    // 查询部门详情
    async organizationInfo() {
      let organizationinfolist = await OrganizationInfo({
        cCompanyID: this.cCompanyID,
        pageSize: 20,
        pageIndex: 1
      })
      if (organizationinfolist.code == 0) {
        if (organizationinfolist.data) {
          fromdataedit[0].inputdata = organizationinfolist.data.ParentId + ""
          fromdataedit[1].inputdata = organizationinfolist.data.CCompanyID
          fromdataedit[2].inputdata = organizationinfolist.data.Name
          fromdataedit[3].inputdata = organizationinfolist.data.Sortnum
          fromdataedit[4].inputdata = organizationinfolist.data.Addition1
          fromdataedit[5].inputdata = organizationinfolist.data.Addition2
          fromdataedit[6].inputdata = organizationinfolist.data.Remark
          this.fromdataedit = fromdataedit
          //console.log("1111")
        }
      }
      //console.log("organizationinfolist", organizationinfolist)
    },
    // 删除部门
    async organizationDelete() {
      let organizationDeletecode = await OrganizationDelete({
        cCompanyID: this.cCompanyID,
      })
      if (organizationDeletecode.code == 0) {
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        this.dialogVisibledel = false
        this.rowboo = false
        this.$parent.organizationList()
      } else if (organizationDeletecode.code == 101) {
        this.$message({
          type: 'warning',
          message: organizationDeletecode.message
        });
        this.rowboo = false
        this.dialogVisibledel = false
      } else {
        this.$message({
          type: 'error',
          message: organizationDeletecode.message
        });
        this.dialogVisibledel = false
      }
      //console.log("organizationDeletecode", organizationDeletecode)
    },
    // 修改部门状态
    async organizationSetEnable() {
      let organizationSetEnableecode = await OrganizationSetEnable({
        cCompanyID: this.cCompanyID,
      })
      if (organizationSetEnableecode.code == 0) {
        this.$message({
          type: 'success',
          message: '启用成功'
        });
        this.dialogVisibleqy = false
        this.$parent.organizationList()
      } else if (organizationSetEnableecode.code == 101) {
        this.$message({
          type: 'warning',
          message: organizationSetEnableecode.message
        });
        this.dialogVisibleqy = false
      } else {
        this.$message({
          type: 'error',
          message: organizationSetEnableecode.message
        });
        this.dialogVisibleqy = false
      }
      //console.log("organizationSetEnableecode", organizationSetEnableecode)
    },
    onRowClick(val) {
      this.rowboo = true
      this.cCompanyID = val.CCompanyID

    },
    adduser() {
      this.dialogVisibles = true
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      //console.log(this.$refs.deptadd, "add")
      this.organizationAdd(this.$refs.deptadd)
      this.dialogVisibles = false
    },
    updateclick() {
      if (this.rowboo == true) {
        this.dialogVisiblesedit = true
        this.organizationInfo()
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要修改的数据！'
      });

    },
    canceledit() {
      this.dialogVisiblesedit = false
    },
    dialogOKedit() {
      //console.log("upadate", this.$refs.deptupdate)
      this.organizationEdit(this.$refs.deptupdate)

    },
    del() {
      if (this.rowboo == true) {
        this.dialogVisibledel = true

        return
      }
      this.$message({
        type: 'error',
        message: '请选择要删除的数据！'
      });
    },
    canceldel() {
      this.dialogVisibledel = false
    },
    dialogOKdel() {
      this.organizationDelete()
    },
    qy() {
      if (this.rowboo == true) {
        this.dialogVisibleqy = true

        return
      }
      this.$message({
        type: 'error',
        message: '请选择要启用的数据！'
      });

    },
    dialogOKqy() {
      this.organizationSetEnable()

    },
    cancelqy() {
      this.dialogVisibleqy = false
    },
    handleChange() {

    }

  },
}
</script>

<style lang="less" scoped>
.incenters {
  height: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20px;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }
  .from {
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // flex-wrap: wrap;
  }

  .signingroles {
    height: 500px;
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // border: 1px solid red;

    .left {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
    }

    .right {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
      // pointer-events: none;
    }
  }
}
.right-s {
  position: absolute;
  z-index: 99;
  opacity: 0.5;
  right: 21px;
  width: 470px;
  height: 240px;
  background-color: #ffffff;
  cursor: no-drop;
}
.dwonleft {
  width: 170px;
  height: 48px;
  position: absolute;
  background-color: #ffffff;
  z-index: 99;
  right: 350px;
  top: 322px;
  text-align: center;
  line-height: 48px;
  color: #333333;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}
.dwonleft:hover {
  background-color: #f0f0f0;
}
</style>
